import * as React from "react"
import { Outlet } from "react-router-dom"
import { useDebounceCallback } from "usehooks-ts"
import { useGoogleAnalytic } from "@allied/react-web/GoogleAnalytic"
import { Header } from "../components/Header"
import { Footer } from "../components/Footer"
import { ToastContainer } from "../components/Toast"
import { Button } from "../components/Contact/Button"
import { ProductService } from "../services/static/Product"

const productService = new ProductService()

export default function Guest(): React.JSX.Element {
  const { analytic } = useGoogleAnalytic()

  const [categories, setCategories] = React.useState([])

  const [, setKeyword] = React.useState("")
  const [search, setSearch] = React.useState({
    show: false,
    loading: false,
    items: []
  })
  const [suggestionItems] = React.useState(["Hydraulic oil", "Engine oil", "Arnica"])
  const setSearchKeyword = useDebounceCallback((keyword?: string) => {
    setKeyword(keyword)
    searchProduct({
      page: 1,
      total_items: 5,
      keyword
    })
  }, 500)

  async function searchCategories() {
    const searchCategories = await productService.SearchCategory({})
    if (searchCategories.error) {
      return
    }

    setCategories(searchCategories.data.items.map((category) => {
      return {
        content: <>{category.name}</>,
        to: `/category/${category.slug}`,
        icon: category.icon
      }
    }))
  }

  async function searchProduct(filter?: Record<string, any>) {
    const keyword = filter.keyword || ""
    if (keyword.length < 3) {
      return
    }

    setSearch((prevState) => {
      return {
        ...prevState,
        show: true,
        loading: true
      }
    })
    const searchProduct = await productService.SearchProduct(filter)
    setSearch((prevState) => {
      return {
        ...prevState,
        loading: false
      }
    })

    analytic.capture("search", {
      search_term: keyword,
    })
    analytic.capture("view_item_list", {
      item_list_id: "search_result",
      item_list_name: "Search Result",
      items: (searchProduct.data.items || []).map((item) => {
        return {
          item_id: item.slug,
          item_name: item.name,
        }
      })
    })
    if (searchProduct.error) {
      return
    }
    setSearch((prevState) => {
      return {
        ...prevState,
        items: searchProduct.data.items.map((item) => {
          return {
            slug: item.slug,
            name: item.name,
            url: `${process.env.REACT_APP_PUBLIC_URL}/product/${item.slug}`,
          }
        })
      }
    })
  }

  function clearSearch() {
    setSearch((prevState) => {
      return {
        ...prevState,
        show: false,
        items: []
      }
    })
  }

  React.useEffect(() => {
    searchCategories()
  }, [])

  return (
    <>
      <Header.AlliedMarine
        logoUrl="/"
        logoImage="/image/acsm-logo.png"
        logoDescription={<>ACS MARINE & <br />SHIPPING PTE LTD</>}
        sublogoImage="/image/eni-logo.png"
        sublogoDescription={<>authorized distributor <br /> of <span className="font-bold">eni</span> lubricants</>}
        menuItems={[
          {
            content: <>Home</>,
            to: "/",
            items: []
          },
          {
            content: <>Products</>,
            to: "/product",
            items: [
              {
                content: <>All Products</>,
                to: "/product",
                items: categories
              }
            ]
          },
          {
            content: <>Contact Us</>,
            to: "/contact",
            items: []
          },
        ]}
        searchLoading={search.loading}
        searchShow={search.show}
        searchItems={search.items}
        suggestionItems={suggestionItems}
        onSelectItem={(item) => {
          clearSearch()

          analytic.capture("select_item", {
            item_list_id: "search_result",
            item_list_name: "Search Result",
            items: [
              {
                item_id: item.slug || null,
                item_name: item.name,
              }
            ]
          })
        }}
        onSearchClose={() => {
          clearSearch()
        }}
        onSearch={({ keyword }: { keyword: string }) => {
          setSearchKeyword(keyword)
        }}
        sticky />
      <ToastContainer />
      <div className="font-verdana sm:!font-poppins min-h-screen">
        <Outlet />
      </div>
      <Footer.AlliedMarine
        logoImage="/image/acsm-logo.png"
        logoUrl="/"
        logoDescription={<>ACS MARINE & <br />SHIPPING PTE LTD</>}
        sublogoImage="/image/eni-logo.png"
        sublogoDescription={<>authorized distributor <br /> of <span className="font-bold">eni</span> lubricants</>}
        menuItems={[
          {
            content: <>Products</>,
            to: "/product",
            items: categories.map((category) => {
              return {
                content: category.content,
                to: category.to,
              }
            })
          },
          {
            content: <>Help</>,
            items: [
              {
                content: <>Contact Us</>,
                to: "/contact",
              },
              {
                content: <>Privacy Policy</>,
                to: "/privacy-policy",
              },
              {
                content: <>General Terms & Conditions</>,
                to: "/terms-conditions",
              }
            ]
          },
        ]}
      />
      <Button />
    </>
  )
}
